import { useEffect } from 'react';
import { Button, Col, Form, Input, Row, Typography } from 'antd';
import { useLogin } from "./hooks/HookLogin";
import { useParams } from 'react-router-dom';

const onFinishFailed = errorInfo => {
    //console.log('Failed:', errorInfo);
};


const AccountValidation = () => {
    const [form] = Form.useForm();
    const { token } = useParams();

    const { onValidateToken, onConfirmAccountEgresado } = useLogin();

    useEffect(() => {
        if (!token) return;
        onValidateToken(token);
    }, []);

    const onFinish = async () => {
        const data = { "token": token };
        await onConfirmAccountEgresado(data);
    };


    return (
        <Form
            name="passwordReset"
            form={form}
            style={{ maxWidth: 600 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
        >
            <Row align="center" justify="center" style={{ textAlign: 'justify' }} >
                <Col span={20} style={{ marginBottom: '20px', marginTop: '20px' }}>
                    <Typography.Title level={3}>
                        Estimado(a) egresado(a),
                    </Typography.Title>
                    <Typography.Text >
                        Es un honor darle la bienvenida a nuestro espacio de egresados. Con el fin de activar su cuenta y acceder a los beneficios, servicios y recursos exclusivos que hemos preparado para usted, le solicitamos dar clic en el siguiente enlace:
                    </Typography.Text>



                </Col>
                <Col span={20} align="center">
                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            Activar cuenta
                        </Button>
                    </Form.Item>
                </Col>
                <Col span={20} style={{ marginBottom: '20px', marginTop: '20px' }}>
                    <Typography.Text italic  >
                        Agradecemos su confianza y reiteramos nuestro compromiso con su crecimiento personal y profesional como parte de la comunidad de egresados.
                    </Typography.Text>
                </Col>
            </Row>
        </Form>
    )
};
export default AccountValidation;